/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { useNavigate } from "react-router-dom";
import { Button, Input, Table } from "../../../components";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { DownloadAssociateBookingList } from "../../../utilities/api/associateBooking";
import { toast } from "react-toastify";
import { DownloadModal } from "../CourtsBooking/DownloadModal";
import {
  AllAssociateBookingList,
  setAssociateColumn,
} from "../../../redux/Slice/AssociateBooking/AssociateBookingListSlice";

const ListOfAssociateBooking = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    AllAssociateBooking,
    currentPage,
    rowsPerPage,
    totalPage,
    totalRows,
    associateColumns,
  } = useAppSelector((state) => state.AssociateBookingList);
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [facilityId, setFacilityId] = useState<any>(SelectedFacility || "");
  const [sportName, setSportName] = useState("");
  const [bookingStatus, setBookingStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const [sorting, setSorting] = useState({ column: "", order: "" });
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const orderColComing = [
    "fullName",
    "bookingDate",
    "startDate",
    "endDate",
    "facilityName",
    "sportName",
    "status",
    "paymentStatus",
  ];
  const orderColSend = [
    "firstName",
    "createdAt",
    "startDate",
    "endDate",
    "facility",
    "sport",
    "status",
    "paymentStatus",
  ];

  const orderByColumn = (col: string) => {
    if (orderColComing.includes(col))
      return orderColSend[orderColComing.indexOf(col)];
    else return "";
  };
  const orderCol = orderByColumn(sorting.column);

  const convertDate = (date: string) =>
    date?.split("-").reverse().join("-")
      ? date?.split("-").reverse().join("-")
      : "";

  useEffect(() => {
    if (key.length <= 0)
      dispatch(
        AllAssociateBookingList({
          page: "1",
          key: "",
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
          facilityId: facilityId,
          sportId: sportName,
          bookingStatus: bookingStatus,
          paymentStatus: paymentStatus,
          orderByCol: "",
          orderBy: "",
        })
      );
  }, [key]);

  const handleAdd = () => {
    navigate("/create-associate-booking");
  };

  const handleUserInfo = (id: any) => {
    navigate("/associate-booking-details", { state: id });
  };

  const NextPage = (nextpage: number) => {
    dispatch(
      AllAssociateBookingList({
        page: nextpage,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        facilityId: facilityId,
        sportId: sportName,
        bookingStatus: bookingStatus,
        paymentStatus: paymentStatus,
        orderByCol: orderCol,
        orderBy: sorting.order,
      })
    );
  };

  const PreviousPage = (prevpage: number) => {
    dispatch(
      AllAssociateBookingList({
        page: prevpage,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        facilityId: facilityId,
        sportId: sportName,
        bookingStatus: bookingStatus,
        paymentStatus: paymentStatus,
        orderByCol: orderCol,
        orderBy: sorting.order,
      })
    );
  };

  const handleSearch = () => {
    dispatch(
      AllAssociateBookingList({
        page: "1",
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        facilityId: facilityId,
        sportId: sportName,
        bookingStatus: bookingStatus,
        paymentStatus: paymentStatus,
        orderByCol: "",
        orderBy: "",
      })
    );
  };

  const handleFromDate = (e: any) => {
    setFromDate(e?.format("DD-MM-YYYY"));
  };

  const handleToDate = (e: any) => {
    setToDate(e?.format("DD-MM-YYYY"));
  };

  const handleSearchByDate = () => {
    dispatch(
      AllAssociateBookingList({
        page: "1",
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        facilityId: facilityId,
        sportId: sportName,
        bookingStatus: bookingStatus,
        paymentStatus: paymentStatus,
        orderByCol: "",
        orderBy: "",
      })
    );
  };

  useEffect(() => {
    setFacilityId(SelectedFacility || "");
    if (isMounted) {
      dispatch(
        AllAssociateBookingList({
          page: "1",
          key: key,
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
          facilityId: SelectedFacility ? SelectedFacility : "",
          sportId: sportName,
          bookingStatus: bookingStatus,
          paymentStatus: paymentStatus,
          orderByCol: "",
          orderBy: "",
        })
      );
    } else {
      setIsMounted(true);
    }
  }, [SelectedFacility]);



  useEffect(() => {
    if (isMounted) {
      dispatch(
        AllAssociateBookingList({
          page: "1",
          key: key,
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
          facilityId: SelectedFacility ? SelectedFacility : "",
          sportId: sportName,
          bookingStatus: bookingStatus,
          paymentStatus: paymentStatus,
          orderByCol: orderCol,
          orderBy: sorting.order,
        })
      );
    } else {
      setIsMounted(true);
    }
  }, [sorting]);

  const ColValue = [
    "Customer Name",
    "Contact Number",
    "Associate Name",
    "Booking Date",
    "Start Date",
    "End Date",
    "Booking Status",
    "Facility Name",
    "Sport Name",
    "Payment Mode",
    "Payment Status",
    "Amount",
  ];
  const ColLabelKey = [
    "fullName",
    "phone",
    "companyName",
    "bookingDate",
    "startDate",
    "endDate",
    "status",
    "facilityName",
    "sportName",
    "paymentMode",
    "paymentStatus",
    "totalAmount",
  ];
  const AllColumn = ColValue.map((item, index) => ({
    value: item,
    labelKey: ColLabelKey[index],
  }));

  const defaultColumn = [...associateColumns].map((item) => item.accessor);

  const handleChange = (value: any) => {
    const col = value.selectedValue.map((item: string, index: number) => {
      return {
        Header: item,
        accessor: value.selectedKey[index],
      };
    });

    dispatch(setAssociateColumn(col));
  };



  const handleClear = () => {
    setKey("");
    setFromDate("");
    setToDate("");
    setSportName("");
    setBookingStatus("");
    setPaymentStatus("");
    setSorting({ column: "", order: "" });
    dispatch(
      AllAssociateBookingList({
        page: "1",
        key: "",
        fromDate: "",
        toDate: "",
        facilityId: SelectedFacility,
        sportId: "",
        bookingStatus: "",
        paymentStatus: "",
        orderByCol: "",
        orderBy: "",
      })
    );
  };

  const handleDownload = async () => {
    const result = await DownloadAssociateBookingList({
      key: key,
      fromDate: convertDate(fromDate),
      toDate: convertDate(toDate),
      facilityId: SelectedFacility,
      sportId: sportName,
      bookingStatus: bookingStatus,
      paymentStatus: paymentStatus,
      orderByCol: orderCol,
      orderBy: sorting.order,
    });
    if (result.statusCode === 200) {
      setDownloadModalOpen(false);
      const url = result.data.fileUrl;
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } else {
      toast.error(result.response.data.message);
    }
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Associate Booking List</Card.Title>
            <ButtonGroup>

              {AllAssociateBooking.length !== 0 && (
                <Button
                  onClick={() => setDownloadModalOpen(true)}
                  type="button"
                  bname="Download Reports"
                  name="download-reports"
                  id="download-reports"
                  className="btn btn-primary rounded-1 me-2"
                ></Button>
              )}
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Booking"
                name="add-booking"
                id="add-booking"
                className="btn btn-primary rounded-1 me-2"
              ></Button>
              <BootstrapSelect
                options={AllColumn}
                isMultiSelect={true}
                showTick={true}
                defaultOptions={defaultColumn}
                className="edit-column"
                selectStyle="btn-primary"
                actionBtnStyle="btn-outline-primary"
                showSearch={true}
                showAction={true}
                placeholder="Edit Column"
                onChange={handleChange}
              />
            </ButtonGroup>
          </div>
          <Row className="row-mb">
            <Col lg={3} style={{ paddingTop: "31px" }}>
              <div className="text-start">
                <InputGroup>
                  <Input
                    value={key}
                    type="text"
                    id="search-booking"
                    name="search-booking"
                    className="form-control form-control-sm h-auto"
                    placeholder="Search . . ."
                    onChange={(e: any) => setKey(e.target.value)}
                  />
                  <Button
                    disabled={key.length < 3}
                    onClick={handleSearch}
                    type="button"
                    bname="Search"
                    name="search-button"
                    id="search-button"
                    className="btn btn-primary btn-sm rounded-1"
                  />
                </InputGroup>
                {key.length > 0 && key.length < 3 && (
                  <span className="error-msg">Minimum 3 characters required</span>
                )}
              </div>
            </Col>
            <Col lg={4}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={<InputIcon className="form-control form-control-sm h-auto" />}
              />
            </Col>
            <Col lg={4} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                  minDate={new Date(fromDate?.split("-").reverse().join("-"))}
                />
                <Button
                  onClick={handleSearchByDate}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {/* {fromDate ||
              toDate ||
              key ||
              sportName ||
              bookingStatus ||
              paymentStatus ||
              sorting.column.length ? (
                <div
                  onClick={handleClear}
                  className="btn btn-link position-absolute top-0"
                  style={{ cursor: "pointer", left: "90%", paddingTop:"31px" }}
                >
                  Clear
                </div>
              ) : (
                ""
              )} */}
            </Col>
            <Col lg={1} style={{ paddingTop: "31px" }}>
              {fromDate ||
              toDate ||
              key ||
              sportName ||
              bookingStatus ||
              paymentStatus ||
              sorting.column.length ? (
                <div
                  onClick={handleClear}
                  className="btn btn-link"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={associateColumns}
            data={AllAssociateBooking}
            HandleShow={handleUserInfo}
            hideEditAction={true}
            hideViewAction={false}
            hideDeleteAction={true}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPage={totalPage}
            totalRows={totalRows}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            show={true}
            isSorting={true}
            sorting={sorting}
            setSorting={setSorting}
            orderColComing={orderColComing}
          />
        </div>
      </Card>

      <DownloadModal
        downloadModalOpen={downloadModalOpen}
        setDownloadModalOpen={setDownloadModalOpen}
        handleDownload={handleDownload}
      />
    </>
  );
};

export { ListOfAssociateBooking };
